<div class="container-fluid payments-due-view">

	<mat-progress-bar *ngIf="ShowProgressBar" mode="indeterminate"></mat-progress-bar>

	<div *ngIf="!ShowProgressBar && rows.length" class="summary">
		<span class="summary-item"><strong>{{ rows.length }}</strong> outstanding</span>
		<span *ngIf="overdueCount" class="summary-item summary-overdue"><strong>{{ overdueCount }}</strong> overdue</span>
		<span class="summary-item">Total remaining: <strong>{{ totalRemaining | studioCurrency }}</strong></span>
		<span *ngIf="paidCount" class="summary-item summary-muted">{{ paidCount }} already paid (not shown)</span>
	</div>

	<div class="table-container">

		<table mat-table #displayTable [dataSource]="dataSource" class="mt-4">

			<ng-container matColumnDef="field_payment_date">
				<th mat-header-cell *matHeaderCellDef>Due Date</th>
				<td mat-cell *matCellDef="let element">
					<ng-container *ngIf="element.field_payment_date; else dateTbd">{{ reportDateService.formatDate(element.field_payment_date) }}</ng-container>
					<ng-template #dateTbd>
						TBD
						<small *ngIf="lessonsRemaining(element) !== null" class="d-block text-muted text-nowrap">at {{ lessonsRemaining(element) }} lessons remaining</small>
					</ng-template>
				</td>
			</ng-container>

			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef>Status</th>
				<td mat-cell *matCellDef="let element">
					<span class="status-badge" [ngClass]="'status-' + (element.status === 'unscheduled' ? 'upcoming' : element.status)">{{ statusLabel(element.status) }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="field_payment_amount">
				<th mat-header-cell *matHeaderCellDef class="text-end">Amount Due</th>
				<td mat-cell *matCellDef="let element" class="text-end">
					<ng-container *ngIf="element.withTax; else amountNoTax">
						{{ element.withTax.amount | studioCurrency }}
						<small class="d-block text-muted text-nowrap">{{ element.field_payment_amount | studioCurrency }} + {{ element.withTax.tax | studioCurrency }} {{ taxMode?.label }}</small>
					</ng-container>
					<ng-template #amountNoTax>{{ element.field_payment_amount | studioCurrency }}</ng-template>
				</td>
			</ng-container>

			<ng-container matColumnDef="field_amount_paid">
				<th mat-header-cell *matHeaderCellDef class="text-end">Paid</th>
				<td mat-cell *matCellDef="let element" class="text-end">
					<ng-container *ngIf="element.withTax?.paidTax; else paidNoTax">
						{{ element.withTax.paid | studioCurrency }}
						<small class="d-block text-muted text-nowrap">{{ (element.field_amount_paid || '0') | studioCurrency }} + {{ element.withTax.paidTax | studioCurrency }} {{ taxMode?.label }}</small>
					</ng-container>
					<ng-template #paidNoTax>{{ (element.field_amount_paid || '0') | studioCurrency }}</ng-template>
				</td>
			</ng-container>

			<ng-container matColumnDef="remaining">
				<th mat-header-cell *matHeaderCellDef class="text-end">Remaining</th>
				<td mat-cell *matCellDef="let element" class="text-end">
					<ng-container *ngIf="element.withTax; else remainingNoTax">
						{{ element.withTax.remaining | studioCurrency }}
						<small class="d-block text-muted text-nowrap">{{ element.remaining | studioCurrency }} + {{ element.withTax.remainingTax | studioCurrency }} {{ taxMode?.label }}</small>
					</ng-container>
					<ng-template #remainingNoTax>{{ element.remaining | studioCurrency }}</ng-template>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"
				[class.row-overdue]="row.status === 'overdue'"></tr>
		</table>

		<p *ngIf="!ShowProgressBar && !loadError && rows.length === 0" class="empty-state">
			No payments are currently due on this enrollment.
			<span *ngIf="paidCount">({{ paidCount }} scheduled payment{{ paidCount === 1 ? '' : 's' }} already paid.)</span>
		</p>
		<p *ngIf="loadError" class="empty-state">
			Unable to load payments due. Please try again.
		</p>

	</div>
</div>
